import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectContract,
  selectPreviousActiveCase,
} from "../../../redux/contract/selectors";
import { postTaxonomy } from "../../../redux/taxonomies/thunks";
import { selectTaxonomy } from "../../../redux/taxonomies/selectors";
import {
  selectCaseStates,
  selectCaseStatesLoading,
} from "../../../redux/caseStates/selectors";
import { getCaseStates } from "../../../redux/caseStates/thunks";
import { getTemplates } from "../../../redux/templates/thunks";
import { selectTemplatesLoading } from "../../../redux/templates/selectors";
import {
  selectEntryChannels,
  selectEntryChannelsLoading,
} from "../../../redux/entryChannels/selectors";
import { CommentSection } from "./CommentSection";
import { Header } from "./header/Header";
import { TaxonomyForm } from "./TaxonomyForm";
import {
  updateCase,
  createCase,
  newCase,
  getContractByCaseId,
  getCommentByCaseId,
  updateContractData,
  attachIdtProcessToCase,
} from "../../../redux/contract/thunks";
import { openModal } from "../../../redux/modal/modalSlice";
import { clearTaxonomyFields } from "../../../redux/taxonomies/taxonomySlice";
import {
  convertToUTC,
  convertToLocalTime,
  deleteStrangeCharacters,
  _base64ToArrayBuffer,
  stringFormat,
} from "../../../commonFunctions/commonFunctions";
import { NoneSelectedMessage } from "../../common/NoneSelected";
import DocumentationForm from "./forms/documentation/DocumentationForm";
import {
  removeActiveHistory,
  updateExceptionChecked,
} from "../../../redux/contract/contractSlice";
import {
  clearCurrentCase,
  updateCaseForm,
  setPreviousCaseState,
} from "../../../redux/currentCase/currentCaseSlice";
import {
  setFormAppointment,
  setFormDocumentation,
  setFormClaims,
  setFormInformation,
  setFormTerminations,
  setFormSubstitutionVehicle,
  setFormDelivery,
  setFormOvc,
  setFormItv,
} from "../../../redux/caseForms/caseFormSlice";
import { isCaseBlockedByUser } from "../../../redux/cases/thunks";
import {
  blockCase,
  unBlockCase,
  updateClickToCall,
} from "../../../redux/currentCase/thunks";
import {
  selectWorkshopSearchResults,
  selectWorkshopSearchFilters,
} from "../../../redux/workshopSearch/selectors";
import dayjs from "dayjs";
import { selectCallId } from "../../../redux/appState/selectors";
import { getEntryChannels } from "../../../redux/entryChannels/thunks";
import { getWorkshopTypes } from "../../../redux/workshopTypes/thunks";
import { selectWorkshopTypes } from "../../../redux/workshopTypes/selectors";
import {
  selectCurrentCase,
  selectCurrentCaseLoading,
} from "../../../redux/currentCase/selectors";
import {
  selectFormAppointment,
  selectFormDocumentation,
  selectFormClaims,
  selectFormInformation,
  selectFormTerminations,
  selectFormSubstitutionVehicle,
  selectFormDelivery,
  selectFormOvc,
  selectFormItv,
} from "../../../redux/caseForms/selectors";
import CallTable from "../CallTable/CallTable";
import { getMasterActionResolutions } from "../../../redux/actionResolutions/thunks";
import {
  selectMasterActionResolutions,
  selectActionResolutionsLoading,
} from "../../../redux/actionResolutions/selectors";
import MessageForm from "../message/MessageForm";
import { AddFactoryCommentForm } from "../factoryCaseForm/AddFactoryCommentForm";
import { AdvanceFactoryCaseForm } from "../factoryCaseForm/AdvanceFactoryCaseForm";
import { CaseStates } from "../../../Constantes/CaseStates";

import RadioOptions from "../../common/RadioGroup";
import { Button } from "@material-ui/core";
import saveIconWhite from "../../../images/save-icon-white.svg";
import { FullCaseHistory } from "./FullCaseHistory";
import { useTranslation } from "react-i18next";
import SelectBox from "../../common/CustomSelectBox";
import { selectUserServices } from "../../../redux/services/selectors";
import { getUserServices } from "../../../redux/services/thunks";
import { QUERY_GET_DOWNLOAD_FILE, QUERY_POST_CREATECASE, QUERY_PUT_UPDATECASE } from "../../../fetch/constantQueries";
import { baseRequest } from "../../../fetch/basicThunk";
import saveAs from 'file-saver';
import { errorHandler } from "../../../commonFunctions/errorHandler";

function CaseWrapper(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contract = useSelector(selectContract);
  const workshopSearch = useSelector(selectWorkshopSearchResults);
  const workshopFilters = useSelector(selectWorkshopSearchFilters);
  const currentCase = useSelector(selectCurrentCase);
  const userServices = useSelector(selectUserServices)
  const loadingCase = useSelector(selectCurrentCaseLoading);
  const taxonomyOptions = useSelector(selectTaxonomy);
  const caseStateOptions = useSelector(selectCaseStates);
  const entryChannelsOptions = useSelector(selectEntryChannels);
  const workshopTypes = useSelector(selectWorkshopTypes);
  const caseStateOptionsLoading = useSelector(selectCaseStatesLoading);
  const templatesLoading = useSelector(selectTemplatesLoading);
  const actionResolutionsLoading = useSelector(selectActionResolutionsLoading);
  const entryChannelsLoading = useSelector(selectEntryChannelsLoading);
  const previousActive = useSelector(selectPreviousActiveCase);
  const callId = useSelector(selectCallId);
  const actionResolutionOptions = useSelector(selectMasterActionResolutions);
  const [reloadTaxonomies, setReloadTaxonomies] = useState(true);
  const [disabledButtom, setDisabledButtom] = useState({
    documentation: true,
    messageForm: true,
    advanceFactoryCase: true,
    addFactoryComment: true,
  });
  const [userServiceValue, setUserServiceValue] = useState();
  const [taxonomyValues, setTaxonomyValues] = useState({
    level: undefined,
    taxonomyLevel_1: "",
    taxonomyLevel_2: "",
    taxonomyLevel_3: "",
    taxonomyLevel_4: "",
  });
  const [caseStateValue, setCaseStateValue] = useState("");
  const [scheduleDate, setScheduleDate] = useState(undefined);
  const [scaleDate, setScaleDate] = useState(undefined);
  const [factoryCloseDate, setFactoryCloseDate] = useState(undefined);
  const [nonPPReason, setNonPPReason] = useState("");
  const [comment, setCaseComment] = useState("");
  const [caseCommentAttachments, setCaseCommentAttachments] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [entryChannel, setEntryChannel] = useState("");
  const [actionResolution, setActionResolution] = useState(null);
  const [subState, setSubStateValue] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [caseWorkshop, setCaseWorkshop] = useState(null);

  const [showNewCase, setShowNewCase] = useState(currentCase?.caseId === 0);
  const [closed, setClosed] = useState();
  const [showMessageForm, setshowMessageForm] = useState(false);
  const [showDocumentation, setShowDocumentation] = useState(false);
  const [showCallTable, setShowCallTable] = useState(false);
  const [editClickToCall, setEditClickToCall] = useState(false);
  const [showAdvanceFactoryCaseForm, setShowAdvanceFactoryCaseForm] =
    useState(false);
  const [showAddFactoryCommentForm, setShowAddFactoryCommentForm] =
    useState(false);
  const [showRegressFactoryCaseForm, setShowRegressFactoryCaseForm] =
    useState(false);
  const [showFullHistory, setShowFullHistory] = useState(false);
  const [disabledRegressCase, setDisabledRegressCase] = useState(false);

  const [formType, setFormType] = useState("");
  const [dataForm, setDataForm] = useState({});

  const [dataDocumentation, setDataDocumentation] = useState({
    template: null,
    plate: contract.plate != null ? contract.plate : "",
  });

  const dataFormAppointment = useSelector(selectFormAppointment);
  const dataFormDocumentation = useSelector(selectFormDocumentation);
  const dataFormClaims = useSelector(selectFormClaims);
  const dataFormInformation = useSelector(selectFormInformation);
  const dataFormTerminations = useSelector(selectFormTerminations);
  const dataFormSubstitutionVehicle = useSelector(
    selectFormSubstitutionVehicle
  );
  const dataFormDelivery = useSelector(selectFormDelivery);
  const dataFormOvc = useSelector(selectFormOvc);
  const dataFormItv = useSelector(selectFormItv);

  const [dataEmailForm, setDataEmailForm] = useState({
    email: "",
    cc: "",
    urgent: false,
    plate: contract.plate != null ? contract.plate : "",
    number: "",
    name: "",
    surnames: "",
    workshopId: "",
    workshopType: workshopFilters?.searchOption || "",
    appointmentDate: null,
    subject: "",
    stationId: "",
  });

  useEffect(() => {
    if (contract.contractData) {
      dispatch(
        setFormAppointment({
          ...dataFormAppointment,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
        })
      );
      dispatch(
        setFormDocumentation({
          ...dataFormDocumentation,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          dni: contract.contractData
            ? contract.contractData?.licenseNumber
            : "",
        })
      );
      dispatch(
        setFormClaims({
          ...dataFormClaims,
          name: contract.contractData?.userName ?? "",
          surname: contract.contractData?.userSurnames ?? "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          notes: "",
          email: contract.contractData?.email ?? "",
          urgent: false,
          workshopEntry: null,
          immobilizationReason: "",
          immobilizationTime: null,
        })
      );
      dispatch(
        setFormDelivery({
          ...dataFormDelivery,
          name: contract.contractData?.userName ?? "",
          surname: contract.contractData?.userSurnames ?? "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          notes: "",
          email: contract.contractData?.email ?? "",
        })
      );
      dispatch(
        setFormInformation({
          ...dataFormInformation,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          dni: contract.contractData
            ? contract.contractData?.licenseNumber
            : "",
        })
      );
      dispatch(
        setFormTerminations({
          ...dataFormTerminations,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          dni: contract.contractData
            ? contract.contractData?.licenseNumber
            : "",
        })
      );
      dispatch(
        setFormSubstitutionVehicle({
          ...dataFormSubstitutionVehicle,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
        })
      );
      dispatch(
        setFormOvc({
          ...dataFormOvc,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
          dni: contract.contractData
            ? contract.contractData?.licenseNumber
            : "",
        })
      );
      dispatch(
        setFormItv({
          ...dataFormItv,
          name: contract.contractData?.userName
            ? contract.contractData.userName
            : "",
          surname: contract.contractData?.userSurnames
            ? contract.contractData.userSurnames
            : "",
          email: contract.contractData?.email
            ? contract.contractData.email
            : "",
          phoneNumber:
            contract.contractData?.mobilePhone?.trim() !== ""
              ? contract.contractData?.mobilePhone
              : phoneNumber || "",
        })
      );
    }
  }, [contract.contractData, phoneNumber]);

  //Mostrar formularios
  function handleShowForms(type) {
    setFormType(type);
    if (type == "callTable") {
      setShowCallTable(!showCallTable);
      setshowMessageForm(false);
      setShowDocumentation(false);
      setShowAdvanceFactoryCaseForm(false);
      setShowAddFactoryCommentForm(false);
      return;
    } else {
      setShowCallTable(false);
    }

    if (!disabledButtom[type]) {
      //if (contract.plate || currentCase.withoutPlate) {
      if (contract.id) {
        dispatch(
          isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })
        ).then((data) => {
          if (data.payload) {
            setshowMessageForm(
              type != "messageForm" ? false : !showMessageForm
            );
            setShowDocumentation(
              type != "documentation" ? false : !showDocumentation
            );
            setShowAdvanceFactoryCaseForm(
              type != "advanceFactoryCase" ? false : !showAdvanceFactoryCaseForm
            );
            setShowAddFactoryCommentForm(
              type != "addFactoryComment" ? false : !showAddFactoryCommentForm
            );
            setShowRegressFactoryCaseForm(
              type != "regressFactoryCase" ? false : !showRegressFactoryCaseForm
            );
          } else if (data.payload === false) {
            dispatch(
              openModal({
                type: "warning",
                message: "El caso esta bloqueado por otro usuario.",
              })
            );
          }
        });
      } else {
        setshowMessageForm(false);
        setShowDocumentation(false);
        setShowAdvanceFactoryCaseForm(false);
        setShowAddFactoryCommentForm(false);
        setShowRegressFactoryCaseForm(false);
      }
    }
  }

  //Gestiona el bloqueod/desbloqueo del caso
  function changeBlock(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);

    dispatch(
      isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })
    ).then((data) => {
      if (data.payload) {
        if (currentCase.blockedByUser) {
          dispatch(unBlockCase(currentCase.caseId)).then(() => {});
        } else {
          dispatch(blockCase(currentCase.caseId)).then(() => {});
        }
      } else if (data.payload === false) {
        dispatch(
          openModal({
            type: "warning",
            message: "El caso esta bloqueado por otro usuario.",
          })
        );
      }
    });
  }

  //Gestiona el mostrar un formulario de caso nuevo
  function handleShowNewCase() {
    if (!showNewCase == true) {
      props.handleNewCase(true);
      dispatch(newCase())
        .unwrap()
        .then((data) => {
          setClosed(false);
          dispatch(clearTaxonomyFields());
          dispatch(removeActiveHistory());
          setShowNewCase(!showNewCase);
          setDisabledButtom((prevState) => ({
            ...prevState,
            documentation: false,
            messageForm: true,
          }));
        })
        .catch((error) => {
          return;
        });
    } else {
      dispatch(clearCurrentCase());
      if (previousActive) {
        dispatch(
          getContractByCaseId({ query: `?caseId=${previousActive.caseId}` })
        );
        setAllButtonsToState({ disabled: false });
      }
      setShowNewCase(!showNewCase);
    }
    setReloadTaxonomies(true);
  }

  function setAllButtonsToState(value) {
    const buttonsObject = { ...disabledButtom };
    const allButtons = Object.keys(buttonsObject);
    allButtons.forEach((button) => {
      buttonsObject[button] = value.disabled;
    });
    setDisabledButtom(buttonsObject);
  }

  function handleCaseComment(value) {
    const allowedChars = deleteStrangeCharacters(value);
    setCaseComment(allowedChars);
    dispatch(updateCaseForm({ currentComment: value }));
  }

  function handleCaseCommentAttachment(e) {
    if (e.target.files) {
      const maxNameLength = 12;
      const filesArray = Array.from(e.target.files).map(file => ({
        file: file,
        name: file.name,
        nameMin: file.name.length > maxNameLength ? `${file.name.substring(0, maxNameLength)}...` : file.name,
        size: file.size ? `${(file.size / 1024 / 1024).toFixed(1)} MB` : '1.5 MB'
      }));
      setCaseCommentAttachments(prev => [...prev, ...filesArray]);
    }
  };

  function removeCaseCommentAttachment(index) {
    setCaseCommentAttachments(prev => prev.filter((_, i) => i !== index));
  };

  function handleChangeCaseNumber(value) {
    setCaseNumber(value);
    dispatch(updateCaseForm({ caseNumber: value }));
  }

  function handleChangeAdditionalInfo(value) {
    setAdditionalInfo(value);
    dispatch(updateCaseForm({ additionalInfo: value }));
  }

  function handleChangeScheduleDate(e) {
    setScheduleDate(e);
    const date = dayjs(e).format("YYYY-MM-DDTHH:mm:ss");
    dispatch(updateCaseForm({ scheduleDate: date }));
  }

  function handleChangeCaseState(e) {
    setCaseStateValue(e);
    dispatch(
      setPreviousCaseState({ changed: true, value: currentCase.stateId })
    );
    dispatch(updateCaseForm({ stateId: e }));
    dispatch(updateExceptionChecked(false));
    if (subState !== null) {
      const subStateInState = caseStateOptions
        .find((cs) => cs.stateId === e)
        .subStates?.some((sb) => sb.subStateId === subState);
      if (!subStateInState) {
        setSubStateValue(null);
        dispatch(updateCaseForm({ subStateId: null }));
      }
    }
  }
  function handleChangeEntryChannel(e) {
    setEntryChannel(e);
    dispatch(updateCaseForm({ entryChannelId: e }));
  }

  function handleChangeScaleDate(e) {
    setScaleDate(e);
    const date = dayjs(e).format("YYYY-MM-DDTHH:mm:ss");
    dispatch(updateCaseForm({ scaleDate: date }));
  }

  function handleChangeFactoryCloseDate(e) {
    setFactoryCloseDate(e);
    const date = dayjs(e).format("YYYY-MM-DDTHH:mm:ss");
    dispatch(updateCaseForm({ factoryCloseDate: date }));
  }

  function handleChangeNonPPReason(e) {
    setNonPPReason(e);
    dispatch(updateCaseForm({ nonPPReason: e }));
  }

  function handleCheckboxChangeResolution(e) {
    let value;
    if ((actionResolution !== null) & (e.target.value === actionResolution)) {
      e.target.checked = false;
      value = null;
    } else {
      value = e.target.value;
    }
    setActionResolution(value);
    dispatch(updateCaseForm({ actionResolutionId: value }));
  }

  function handleChangeResolution(e) {
    let value;
    if ((actionResolution !== null) & (e.value === actionResolution)) {
      value = null;
    } else {
      value = e.value;
    }

    setActionResolution(value);
    dispatch(updateCaseForm({ actionResolutionId: value }));
  }

  function handleChangeSubState(e) {
    setSubStateValue(e);
    dispatch(updateCaseForm({ subStateId: e }));
    dispatch(updateExceptionChecked(false));
  }


  function handleChangeUserService(e) {
    let value;
    if ((userServiceValue !== null) & (e === userServiceValue)) {
      value = null;
    } else {
      value = e;
    }

    setUserServiceValue(value);
    dispatch(updateCaseForm({ userServiceId: value }));

    if(value == null){
      setTaxonomyValues({
        level: undefined,
        taxonomyLevel_1: "",
        taxonomyLevel_2: "",
        taxonomyLevel_3: "",
        taxonomyLevel_4: "",
      });
    }
    else {
      for (let i = 1; i <= 5; i++) {
        if (i === 1 || currentCase[`taxonomyLevel_${i}`]) {
          dispatch(
            postTaxonomy({
              body: {
                level: i,
                visible: true,
                serviceIds: value != null ? [value] : null,
                taxonomyLevel_1: currentCase.taxonomyLevel_1
                  ? currentCase.taxonomyLevel_1.key
                  : null,
                taxonomyLevel_2: currentCase.taxonomyLevel_2
                  ? currentCase.taxonomyLevel_2.key
                  : null,
                taxonomyLevel_3: currentCase.taxonomyLevel_3
                  ? currentCase.taxonomyLevel_3.key
                  : null,
                taxonomyLevel_4: currentCase.taxonomyLevel_4
                  ? currentCase.taxonomyLevel_4.key
                  : null,
              },
            })
          );
        }
      }
    }
  }

  function handleChangeClickToCall(value) {
    let inputNumber = value;
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = inputNumber.replace(nonDigitsRegExp, "");

    setPhoneNumber(filteredNumber);
  }

  function handleChangeWorkshop(value) {
    if (value) {
      setCaseWorkshop({ workshopInternalId: value });
      dispatch(updateCaseForm({ workshopId: value }));
    }
  }

  //Gestiona el cambio de estado de taxonomías
  function handleTaxonomyChange(value, level) {
    let newState = { level, [`taxonomyLevel_${level}`]: value };

    for (let i = level + 1; i <= 5; i++) {
      newState[`taxonomyLevel_${i}`] = "";
    }
    setTaxonomyValues((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }

  function checkBlockClickToCall(e) {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    dispatch(
      isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })
    ).then((data) => {
      if (data.payload) {
        window.open(e.nativeEvent.target.href);
      } else if (data.payload === false) {
        dispatch(
          openModal({
            type: "warning",
            message: "El caso esta bloqueado por otro usuario.",
          })
        );
      }
    });
  }

  //Envía formulario de crear caso y refresca la store en caso de éxito

  async function handleCreateCase(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);
    const createParams = {
      caseId: 0,
      contractId: contract.id,
      serviceId: userServiceValue,
      taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
      taxonomyLevel_2:
        taxonomyValues.taxonomyLevel_2 !== ""
          ? taxonomyValues.taxonomyLevel_2
          : null,
      taxonomyLevel_3:
        taxonomyValues.taxonomyLevel_3 !== ""
          ? taxonomyValues.taxonomyLevel_3
          : null,
      taxonomyLevel_4:
        taxonomyValues.taxonomyLevel_4 !== ""
          ? taxonomyValues.taxonomyLevel_4
          : null,
      scheduleDate: scheduleDate ? convertToUTC(scheduleDate) : null,
      stateId: caseStateValue,
      subStateId: subState,
      comment: currentCase.currentComment || comment,
      commentAttachments: caseCommentAttachments || [],
      plate: contract.plate,
      additionalInfo: additionalInfo,
      caseNumber: caseNumber == "" ? null : caseNumber,
      entryChannelId: entryChannel,
      callId: callId,
      scaleDate: scaleDate ? convertToUTC(scaleDate) : null,
      factoryCloseDate: factoryCloseDate
        ? convertToUTC(factoryCloseDate)
        : null,
      nonPPReason: nonPPReason,
      actionResolutionId: actionResolution ? Number(actionResolution) : null,
      workshopSearchResult: workshopSearch,
      phoneNumber: phoneNumber,
      workshopId: caseWorkshop?.workshopInternalId,
    };

    if (
      (caseStateValue === currentCase.casePreviousState?.firstState ||
        caseStateValue !== currentCase.casePreviousState?.stateChanged) &&
      !contract?.unassigned &&
      contract?.exceptions.length > 0 &&
      !contract?.checkedExceptions
    ) {
      dispatch(
        openModal({
          type: "warning",
          message: "Por favor, marque que ha leído las exceções",
        })
      );
    } else if (
      phoneNumber &&
      phoneNumber.trim() !== "" &&
      !validateClickToCall(phoneNumber)
    ) {
      dispatch(
        openModal({
          type: "warning",
          message:
            "El número de teléfono debe contener 9 dígitos y ser un número válido",
        })
      );
    } else if (
      caseStateValue !== null &&
      caseStateValue !== "" &&
      currentCase.currentComment != null &&
      currentCase.currentComment != "" &&
      entryChannel != null &&
      entryChannel != "" &&
      entryChannel != 0
    ) {
      let defaultIdtProcessId = contract.case.idtProcessId
        ? contract.case.idtProcessId
        : null;

      // FORM DATA
      let submitFormData = new FormData();
      Object.keys(createParams).forEach(function (key) {
        if (createParams[key] && createParams[key] != null && createParams[key] != undefined) {
          if (key.toLowerCase() == 'commentattachments') {
            if (createParams[key] != [] && createParams[key].length > 0) {
              for (let attachment of createParams[key]) {
                submitFormData.append('commentAttachments', attachment.file);
              }
            }
          } else {
            submitFormData.append(key, createParams[key]);
          }
        }
      });

      //dispatch(createCase({ body: createParams }))
      const data = await baseRequest({ body: submitFormData, excludeContentType: true }, dispatch, QUERY_POST_CREATECASE, 'POST')
      setCaseComment('');
      setCaseCommentAttachments([]);
      dispatch(updateCaseForm({ currentComment: '' }));
      setShowNewCase(false);
      setShowDocumentation(false);
      dispatch(updateExceptionChecked(false));
      dispatch(getContractByCaseId({ query: `?caseId=${data.caseId}` }));
      if (defaultIdtProcessId && !data.payload.idtProcessId)
        dispatch(
          attachIdtProcessToCase({
            body: {
              idtProcessId: defaultIdtProcessId,
              caseId: data.payload.caseId,
            },
          })
        );
    } else {
      if (entryChannel == null || entryChannel == "" || entryChannel == 0) {
        dispatch(
          openModal({
            type: "warning",
            message: stringFormat(t("RequiredFieldTemplate"), t("EntryChannel")),
          })
        );
      } else {
        let mensaje =
          caseStateValue == null || caseStateValue === ""
            ? stringFormat(t("RequiredFieldTemplate"), t("State"))
            : stringFormat(t("RequiredFieldTemplate"), t("Comments")) ;
        dispatch(openModal({ type: "warning", message: mensaje }));
      }
    }
  }

  //Envía formulario de actualizar caso y refresca la store en caso de éxito

  async function handleUpdateCase(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);
    const updateParams = {
      caseId: currentCase.caseId,
      contractId: contract.id,
      serviceId: userServiceValue,
      taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
      taxonomyLevel_2:
        taxonomyValues.taxonomyLevel_2 !== ""
          ? taxonomyValues.taxonomyLevel_2
          : null,
      taxonomyLevel_3:
        taxonomyValues.taxonomyLevel_3 !== ""
          ? taxonomyValues.taxonomyLevel_3
          : null,
      taxonomyLevel_4:
        taxonomyValues.taxonomyLevel_4 !== ""
          ? taxonomyValues.taxonomyLevel_4
          : null,
      scheduleDate: scheduleDate ? convertToUTC(scheduleDate) : null,
      stateId: caseStateValue,
      subStateId: subState,
      comment: currentCase.currentComment || comment,
      commentAttachments: caseCommentAttachments || [],
      additionalInfo: additionalInfo,
      caseNumber: caseNumber == "" ? null : caseNumber,
      plate: contract.unassigned ? null : contract.plate || null,
      entryChannelId: entryChannel,
      scaleDate: scaleDate ? convertToUTC(scaleDate) : null,
      factoryCloseDate: factoryCloseDate
        ? convertToUTC(factoryCloseDate)
        : null,
      nonPPReason: nonPPReason,
      actionResolutionId: actionResolution ? Number(actionResolution) : null,
      workshopSearchResult: workshopSearch,
      phoneNumber: phoneNumber,
      workshopId: caseWorkshop?.workshopInternalId,
    };

    // if ((!contract.plate || contract.unassigned) && !currentCase.withoutPlate) {
    //   dispatch(
    //     openModal({
    //       type: "warning",
    //       message:
    //         "Por favor, guarde la matricula o marque check de sin matricula",
    //     })
    //   );
    // } else if (
    //   caseStateValue !== currentCase.casePreviousState?.stateChanged &&
    //   contract.exceptions?.length > 0 &&
    //   !contract.checkedExceptions &&
    //   !contract?.unassigned
    // ) {
    //   dispatch(
    //     openModal({
    //       type: "warning",
    //       message: "Por favor, marque que ha leído las exceções",
    //     })
    //   );
    // } else if (
    //   phoneNumber &&
    //   phoneNumber.trim() !== "" &&
    //   !validateClickToCall(phoneNumber)
    // ) {
    //   dispatch(
    //     openModal({
    //       type: "warning",
    //       message:
    //         "El número de teléfono debe contener 9 dígitos y ser un número válido",
    //     })
    //   );
    // } else 
    if (
      currentCase.currentComment != null &&
      currentCase.currentComment != "" &&
      entryChannel != null &&
      entryChannel != "" &&
      entryChannel != 0
      //&&
      //(contract.plate || !contract.unassigned || currentCase.withoutPlate)
    ) {
      // FORM DATA
      let submitFormData = new FormData();
      Object.keys(updateParams).forEach(function (key) {
        if (updateParams[key] && updateParams[key] != null && updateParams[key] != undefined) {
          if (key.toLowerCase() == 'commentattachments') {
            if (updateParams[key] != [] && updateParams[key].length > 0) {
              for (let attachment of updateParams[key]) {
                submitFormData.append('commentAttachments', attachment.file);
              }
            }
          } else {
            submitFormData.append(key, updateParams[key]);
          }
        }
      });

      //dispatch(updateCaseByForm({ body: updateParams, excludeContentType: true }));
      const data = await baseRequest({ body: submitFormData, excludeContentType: true }, dispatch, QUERY_PUT_UPDATECASE, 'PUT');
      dispatch(getContractByCaseId({ query: `?caseId=${data.caseId}` }));
      setCaseComment('');
      setCaseCommentAttachments([]);
      dispatch(updateCaseForm({ currentComment: '' }));
      dispatch(updateExceptionChecked(false));
    } else if (
      entryChannel == null ||
      entryChannel == "" ||
      entryChannel == 0
    ) {
      dispatch(
        openModal({
          type: "warning",
          message: stringFormat(t("RequiredFieldTemplate"), t("EntryChannel")),
        })
      );
    } else {
      dispatch(
        openModal({
          type: "warning",
          message: stringFormat(t("RequiredFieldTemplate"), t("Comments")),
        })
      );
    }
  }
  // Carga valores iniciales cada vez que se cambia el caso:

  useEffect(() => {
    if (currentCase && loadingCase !== "loading") {
      if (currentCase.showFactoryApiErrorCreating) {
        dispatch(
          openModal({
            type: "warning",
            message:
              "No se ha podido crear el caso en fábrica. La acción se ejecutará automáticamente más tarde.",
          })
        );
      }
    }
    if (!currentCase) {
      setshowMessageForm(false);
      setShowDocumentation(false);
      setShowNewCase(showNewCase ? showNewCase : false);
      // setAllButtonsToState({disabled: true})
      setAllButtonsToState({ disabled: true });
    }
    if (loadingCase !== "loading" && currentCase != null && reloadTaxonomies) {
      setshowMessageForm(false);
      setShowDocumentation(false);
      //if (contract.plate && !contract.unassigned) {
      if (contract.id) {
        setAllButtonsToState({ disabled: false });
      }
      if (currentCase.withoutPlate) {
        setDisabledButtom((prevState) => ({
          ...prevState,
          documentation: true,
        }));
      }
      if (!currentCase.caseNumber || !currentCase.factoryInteractionAllowed) {
        setDisabledRegressCase(true);
      } else {
        setDisabledRegressCase(false);
      }
      if (!currentCase.factoryInteractionAllowed) {
        setDisabledButtom((prevState) => ({
          ...prevState,
          advanceFactoryCase: true,
        }));
      }

      setAdditionalInfo(
        currentCase.additionalInfo == null ? "" : currentCase.additionalInfo
      );
      setCaseNumber(
        currentCase.caseNumber == null ? "" : currentCase.caseNumber
      );
      setEntryChannel(
        currentCase.entryChannelId ? currentCase.entryChannelId : ""
      );
      setPhoneNumber(currentCase.phoneNumber ? currentCase.phoneNumber : "");
      setCaseWorkshop(
        currentCase.workshopId
          ? {
              workshopInternalId: currentCase.workshopId,
              name: currentCase.workshop,
            }
          : null
      );

      if (currentCase.caseId > 0) {
        setShowNewCase(false);
        if (
          contract.case.stateId == CaseStates.CLOSED ||
          contract.case.stateId == CaseStates.FACTORY_PROCESS ||
          contract.case.stateId == CaseStates.FACTORY_PROCESS_RETURN
        ) {
          setDisabledButtom((prevState) => ({
            ...prevState,
            documentation: true,
          }));
        } else {
          setDisabledButtom((prevState) => ({
            ...prevState,
            documentation: false,
          }));
        }
      } else {
        setDisabledButtom((prevState) => ({ ...prevState, messageForm: true }));
      }

      caseStateOptionsLoading !== "succeeded" && dispatch(getCaseStates());
      templatesLoading !== "succeeded" && dispatch(getTemplates());
      entryChannelsLoading !== "succeeded" && dispatch(getEntryChannels());
      actionResolutionsLoading !== "succeeded" &&
        dispatch(getMasterActionResolutions());

      setDataForm({
        email: contract.contractData?.email ? contract.contractData.email : "",
        name: contract.contractData?.userName || "",
        surname: contract.contractData?.userSurnames || "",
        phoneNumber: contract.contractData?.mobilePhone || phoneNumber,
        tyreSize: "",
        orangeLightPilot: false,
        itvBonus: false,
        originalDocItv: false,
        numberOfTyres: 2,
      });

      dispatch(getUserServices());

      setUserServiceValue(currentCase?.serviceId);
      if(currentCase?.serviceId){
        for (let i = 1; i <= 5; i++) {
          if (i === 1 || currentCase[`taxonomyLevel_${i}`]) {
            dispatch(
              postTaxonomy({
                body: {
                  level: i,
                  visible: true,
                  serviceIds: currentCase?.serviceId != null ? [currentCase?.serviceId] : null,
                  taxonomyLevel_1: currentCase.taxonomyLevel_1
                    ? currentCase.taxonomyLevel_1.key
                    : null,
                  taxonomyLevel_2: currentCase.taxonomyLevel_2
                    ? currentCase.taxonomyLevel_2.key
                    : null,
                  taxonomyLevel_3: currentCase.taxonomyLevel_3
                    ? currentCase.taxonomyLevel_3.key
                    : null,
                  taxonomyLevel_4: currentCase.taxonomyLevel_4
                    ? currentCase.taxonomyLevel_4.key
                    : null,
                },
              })
            );
          }
        }
      }

      setTaxonomyValues((prevState) => ({
        ...prevState,
        ...{
          taxonomyLevel_1: currentCase.taxonomyLevel_1
            ? currentCase.taxonomyLevel_1.key
            : null,
          taxonomyLevel_2: currentCase.taxonomyLevel_2
            ? currentCase.taxonomyLevel_2.key
            : null,
          taxonomyLevel_3: currentCase.taxonomyLevel_3
            ? currentCase.taxonomyLevel_3.key
            : null,
          taxonomyLevel_4: currentCase.taxonomyLevel_4
            ? currentCase.taxonomyLevel_4.key
            : null,
        },
      }));

      setCaseStateValue(currentCase.stateId);
      setSubStateValue(currentCase.subStateId);
      dispatch(
        setPreviousCaseState({ changed: false, value: currentCase.stateId })
      );
      setScheduleDate(
        currentCase.scheduleDate
          ? convertToLocalTime(currentCase.scheduleDate)
          : null
      );
      setCaseComment("");
      setScaleDate(
        currentCase.scaleDate ? convertToLocalTime(currentCase.scaleDate) : null
      );
      setFactoryCloseDate(
        currentCase.factoryCloseDate
          ? convertToLocalTime(currentCase.factoryCloseDate)
          : null
      );
      setNonPPReason(
        currentCase.nonPPReason == null ? "" : currentCase.nonPPReason
      );

      setActionResolution(currentCase.actionResolutionId || null);
    }
  }, [currentCase?.caseId, loadingCase, contract.unassigned]);

  useEffect(() => {
    if (Object.keys(workshopTypes.workshopTypes).length == 0) {
      dispatch(getWorkshopTypes());
    }
  }, [contract]);

  // Cada vez que se cambia el valor de la taxonomía de un nivel, carga los valores del siguiente nivel de taxonomía
  useEffect(() => {
    if (taxonomyValues.level) {
      if (taxonomyValues.level <= 4) {
        dispatch(
          postTaxonomy({
            body: {
              visible: true,
              level:
                taxonomyValues.level < 4
                  ? taxonomyValues.level + 1
                  : taxonomyValues.level,
              serviceIds: userServiceValue != null ? [userServiceValue] : null,
              taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
              taxonomyLevel_2: taxonomyValues.taxonomyLevel_2,
              taxonomyLevel_3: taxonomyValues.taxonomyLevel_3,
              taxonomyLevel_4: taxonomyValues.taxonomyLevel_4,
            },
          })
        );
      }
      let level = taxonomyValues.level;
      if (taxonomyOptions[`level_${level}`]) {
        let updateTax = {};
        let taxonomyWithDescription = taxonomyOptions[`level_${level}`].find(
          (o) => o.key === taxonomyValues[`taxonomyLevel_${level}`]
        );
        if (taxonomyWithDescription === undefined) {
          taxonomyWithDescription = { key: null, value: null, parentKey: null };
        }
        updateTax[`taxonomyLevel_${level}`] = taxonomyWithDescription;

        for (let i = level + 1; i <= 4; i++) {
          updateTax[`taxonomyLevel_${i}`] = {
            key: null,
            value: null,
            parentKey: null,
          };
        }

        dispatch(updateCaseForm(updateTax));
      }
    }
  }, [taxonomyValues]);

  useEffect(() => {
    if (caseStateOptionsLoading === "succeeded" && contract.case) {
      setClosed(isClosed(contract.case.stateId));
    }
  }, [caseStateOptionsLoading, contract.case]);

  //Mira si el caso esta cerrado
  function isClosed(state = null) {
    let closed = false;
    if (state === CaseStates.CLOSED) {
      closed = true;
    }
    return closed;
  }

  //Edita el campo click to call

  useEffect(() => {
    if (editClickToCall) {
      document.getElementById("input-click-to-call").focus();
    }
  }, [editClickToCall]);

  useEffect(() => {
    if (closed) {
      cancelEditClickToCall();
    }
  }, [closed]);

  function validateClickToCall() {
    if (!phoneNumber) {
      return false;
    }
    return phoneNumber.match(/^[6789]\d{8}$/gm);
  }

  function saveClickToCall() {
    if (!validateClickToCall(phoneNumber)) {
      dispatch(
        openModal({
          type: "warning",
          message:
            "El número de teléfono debe contener 9 dígitos y ser un número válido",
        })
      );
      return;
    }

    dispatch(
      updateClickToCall({
        query: `?caseId=${currentCase.caseId}&newNumber=${phoneNumber}`,
      })
    );
    setEditClickToCall(false);
  }

  function cancelEditClickToCall() {
    setPhoneNumber(currentCase.phoneNumber);
    setEditClickToCall(false);
  }

  async function downloadHistoryFile(blobGuid) {
    try {
      const data = await baseRequest({ param: `${blobGuid}` }, dispatch, QUERY_GET_DOWNLOAD_FILE, 'GET');
      if (data != '') {
        saveAs(new Blob([_base64ToArrayBuffer(data.fileBinary)], { type: data.contentType }), data.fileName);
      } else {
        dispatch(openModal({ type: 'warning', message: 'Erro ao baixar arquivo.' }));
      }
    } catch (error) {
      dispatch(openModal(errorHandler(error)));
    } finally {
    }
  }
  return (
    <>
      <Header
        phoneNumber={phoneNumber}
        saveClickToCall={saveClickToCall}
        cancelEditClickToCall={cancelEditClickToCall}
        editClickToCall={editClickToCall}
        setEditClickToCall={setEditClickToCall}
        handleChangeClickToCall={handleChangeClickToCall}
        checkBlockClickToCall={checkBlockClickToCall}
        showCallTable={contract?.case}
        showMessageForm={showMessageForm}
        showDocumentation={showDocumentation}
        showAdvanceFactoryCaseForm={showAdvanceFactoryCaseForm}
        showAddFactoryCommentForm={showAddFactoryCommentForm}
        showRegressFactoryCaseForm={showRegressFactoryCaseForm}
        handleShowForms={handleShowForms}
        changeBlock={changeBlock}
        plate={contract.plate}
        closed={closed}
        setShowNewCase={handleShowNewCase}
        showNewCase={showNewCase}
        loading={loadingCase}
        currentCase={currentCase}
        createCase={handleCreateCase}
        saveChanges={handleUpdateCase}
        disabledButtom={disabledButtom}
        disabledRegressCase={disabledRegressCase}
        setShowFullHistory={() => setShowFullHistory(!showFullHistory)}
      />
      <>
        <MessageForm
          disabledSms={disabledButtom.messageForm}
          disabledButtom={disabledButtom}
          phoneNumber={phoneNumber}
          handleShowForms={handleShowForms}
          setAllButtonsToState={setAllButtonsToState}
          setDisabledButtom={setDisabledButtom}
          setshowMessageForm={setshowMessageForm}
          showMessageForm={showMessageForm}
        ></MessageForm>
        <DocumentationForm
          disabledButtom={disabledButtom.documentation}
          dataDocumentation={dataDocumentation}
          setDataEmailForm={setDataEmailForm}
          setAllButtonsToState={setAllButtonsToState}
          setDisabledButtom={setDisabledButtom}
          phoneNumber={phoneNumber}
          showDocumentation={showDocumentation}
          handleShowForms={handleShowForms}
        ></DocumentationForm>
        <FullCaseHistory
          open={showFullHistory}
          closeFunction={() => setShowFullHistory(!showFullHistory)}
          caseId={currentCase?.caseId}
          caseComments={currentCase?.comments}
        />
        {contract?.case ? (
          <CallTable
            handleShowForms={handleShowForms}
            showCallTable={showCallTable}
            contractCalls={contract?.case?.calls}
            contractEmails={contract?.case?.emails}
          ></CallTable>
        ) : (
          <></>
        )}
        {(currentCase != null &&
          Object.keys(currentCase).length !== 0 &&
          currentCase.caseId != undefined &&
          currentCase.caseId > 0) ||
        showNewCase ? (
          <>
            <AddFactoryCommentForm
              currentCaseId={currentCase?.caseId}
              processId={currentCase?.factoryProcessId}
              expedient={currentCase?.caseNumber}
              handleShowForms={handleShowForms}
              showAddFactoryCommentForm={showAddFactoryCommentForm}
              setShowAddFactoryCommentForm={setShowAddFactoryCommentForm}
              formClassName={"factory-header-form"}
              anchorId={"add-factory-comment-button"}
            />
            <AdvanceFactoryCaseForm
              setDisabledButtom={setDisabledButtom}
              handleShowForms={handleShowForms}
              showRegressFactoryCaseForm={showRegressFactoryCaseForm}
              setShowRegressFactoryCaseForm={setShowRegressFactoryCaseForm}
              showAdvanceFactoryCaseForm={showAdvanceFactoryCaseForm}
              setShowAdvanceFactoryCaseForm={setShowAdvanceFactoryCaseForm}
            />
            <TaxonomyForm
              closed={closed}
              loading={
                loadingCase === "idle" || loadingCase === "loading"
                  ? true
                  : false
              }
              userServices={userServices}
              userServiceValue={userServiceValue}
              taxonomyValues={taxonomyValues}
              taxonomyOptions={taxonomyOptions}
              caseOptions={caseStateOptions}
              entryChannelsOptions={entryChannelsOptions}
              caseValue={caseStateValue}
              dateValue={scheduleDate}
              additionalInfo={additionalInfo}
              caseNumber={caseNumber}
              entryChannelValue={entryChannel}
              factoryCloseDateValue={factoryCloseDate}
              scaleDateValue={scaleDate}
              nonPPReasonValue={nonPPReason}
              phoneNumber={phoneNumber}
              changeUserService={handleChangeUserService}
              changePhoneNumber={handleChangeClickToCall}
              changeTaxonomy={handleTaxonomyChange}
              changeCaseValue={handleChangeCaseState}
              changeDate={handleChangeScheduleDate}
              changeAdditionalInfo={handleChangeAdditionalInfo}
              changeCaseNumber={handleChangeCaseNumber}
              changeEntryChannel={handleChangeEntryChannel}
              changeFactoryCloseDate={handleChangeFactoryCloseDate}
              changeScaleDate={handleChangeScaleDate}
              changeNonPPReason={handleChangeNonPPReason}
              changeSubState={handleChangeSubState}
              subStateValue={subState}
              workshopValue={caseWorkshop}
              changeCaseWorkshop={handleChangeWorkshop}
            />
            <CommentSection
              showNewCase={showNewCase}
              closed={closed}
              loading={
                loadingCase === "idle" || loadingCase === "loading"
                  ? true
                  : false
              }
              comments={currentCase ? currentCase.comments : null}
              current={(currentCase && currentCase.currentComment) || comment}
              currentAttachments={caseCommentAttachments}
              changeCaseComment={handleCaseComment}
              changeCaseCommentAttachments={handleCaseCommentAttachment}
              removeCommentAttachment={removeCaseCommentAttachment}
              resolution={actionResolution}
              resolutionOptions={actionResolutionOptions}
              changeResolution={handleChangeResolution}
              qmaiAnalysis={currentCase ? currentCase.qmaiAnalysis : null}
              downloadHistoryFile={downloadHistoryFile}
            />

            <div
              style={{
                backgroundColor: "#fff",
                padding: "0.75rem",
                display: "flex",
                justifyContent: "end", // "space-between",
                alignItems: "center",
                gap: '1rem'
              }}
            >
              {/* <RadioOptions
                options={actionResolutionOptions}
                value={actionResolution}
                onChange={handleChangeResolution}
                disabled={closed}
                loading={
                  loadingCase === "idle" || loadingCase === "loading"
                    ? true
                    : false
                }
              /> */}

              <SelectBox
                label={"Resolução"}
                name="Resolução"
                dataSource={actionResolutionOptions}
                showClearButton={true}
                value={actionResolution}
                displayExpr={"actionResolutionName"} 
                valueExpr={"actionResolutionId"}
                onValueChanged={handleChangeResolution}
                searchEnabled={true}
                disabled={closed}
              ></SelectBox>

              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={
                    showNewCase === true ? handleCreateCase : handleUpdateCase
                  }
                  startIcon={<img src={saveIconWhite} />}
                  disabled={closed}
                >
                  {`${t("Save")} ${t("Case")}`}
                </Button>
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              gridRowEnd: 4,
              backgroundColor: "#fff",
              padding: "0.5rem",
            }}
          >
            <NoneSelectedMessage message={t("NoSelectedCase")} />
          </div>
        )}
      </>
    </>
  );
}

export { CaseWrapper };
